/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import clsx from 'clsx';
import React from 'react';

import { AdminNavigation } from '../../components/AdminNavigation/AdminNavigation';
import { ADMIN_NAVIGATION_DRAWER_WIDTH } from '../../constants/settings';
import { FooterLayout } from '../FooterLayout/FooterLayout';
import { HeaderLayout } from '../HeaderLayout/HeaderLayout';
import { useAdminLayoutStyles } from './AdminLayout.styles';

type AdminLayoutProps = {
  children: React.ReactNode;
};

export function AdminLayout(props: AdminLayoutProps) {
  const { children } = props;
  const classes = useAdminLayoutStyles({
    drawerWidth: ADMIN_NAVIGATION_DRAWER_WIDTH,
  });
  return (
    <div className={classes.root}>
      <HeaderLayout
        drawerOpen={true}
        setDrawerOpen={() => {}}
        hideCreateMenu
        drawerWidth={ADMIN_NAVIGATION_DRAWER_WIDTH}
      />
      <AdminNavigation drawerWidth={ADMIN_NAVIGATION_DRAWER_WIDTH} drawerOpen={true} />
      <main
        className={clsx({
          [classes.content]: true,
          [classes.contentShift]: true,
        })}
      >
        <div className={classes.drawerHeader} />
        <div className={classes.contentBox}>{children}</div>
        <FooterLayout />
      </main>
    </div>
  );
}
